import { useMutation, useQueryClient } from '@tanstack/react-query'
import { meetingKeys } from '@/entities/meeting'
import { ApiError, apiDelete } from '@/shared/api'
import { toast } from '@/shared/ui/toast'

// Машиночитаемый code бэка (problem+json) → объяснение, почему удалить нельзя.
function deleteErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    switch (error.code?.toUpperCase()) {
      case 'MEETING_ACTIVE':
        return 'Встреча ещё идёт. Сначала завершите её'
      case 'TRANSCRIPTION_IN_PROGRESS':
        return 'Идёт транскрибация, попробуйте позже'
    }
  }
  return 'Не удалось удалить встречу'
}

export function useDeleteMeeting(meetingId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => apiDelete(`/meetings/${meetingId}`),
    onSuccess: () => {
      toast.success('Встреча удалена')
      // detail не инвалидируем — встречи больше нет, рефетч дал бы 404.
      void qc.invalidateQueries({ queryKey: meetingKeys.lists() })
    },
    onError: (error) => toast.error(deleteErrorMessage(error)),
  })
}
